import GeoPoint from "@/model/GeoPoint";

const NOMINATIM_URL = "https://nominatim.openstreetmap.org/search";

/**
 * Looks an address up with OpenStreetMap's free Nominatim geocoder. Returns null when nothing
 * matches. Nominatim's usage policy allows light, user-triggered use like this (one lookup per click).
 */
async function geocodeAddress(query: string): Promise<GeoPoint | null> {
  const url = `${NOMINATIM_URL}?format=json&limit=1&q=${encodeURIComponent(query)}`;
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Geocoding failed with status ${response.status}`);
  }

  const results = (await response.json()) as { lat: string; lon: string }[];
  if (results.length === 0) {
    return null;
  }

  return {
    latitude: Number(results[0].lat),
    longitude: Number(results[0].lon),
  };
}

export default geocodeAddress;
